export const cleaningPolicy = (name?: string, date?: string) => {
  return [
    { text: 'Company Semi-Truck Cleaning Policy', style: 'h1' },

    { text: "PURPOSE:", style: 'p', bold: true },

    { text: [
        { text: "To maintain the cleanliness and professional appearance of company equipment, all drivers operating a" },
        { text: "company-owned truck", bold: true },
        { text: " are " },
        { text: "REQUIRED", bold: true },
        { text: " to wash the vehicle " },
        { text: "prior to returning to the yard.", bold: true },

      ], style: 'p' },

    { canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 500,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      margin: [0, 20, 0, 10]
    },

    { text: [
        { text: "Eddective immediately, all drivers operating" },
        { text: " company-owned trucks ", bold: true },
        { text: "are required to comply with the following:" },
      ], style: 'p' },

    { text: [
        { text: "Trucks must be " },
        { text: "washed before returning to the yard.", bold: true },
      ], style: 'p', margin: [20, 0, 0, 10] },

    { text: [
        { text: "The " },
        { text: "company will cover the cost ", bold: true },
        { text: "of the wash at approved locations." },
      ], style: 'p', margin: [20, 0, 0, 10] },

    { text: "Drivers may be asked to provide a receipt for verification.", style: 'p', margin: [20, 0, 0, 10] },

    { text: "Failure to comply with this policy may result in:", bold: true, style: 'p' },

    { text: [
        { text: "Assignment to " },
        { text: "olders or less-preferred trucks.", bold: true },
      ], style: 'p', margin: [20, 0, 0, 10] },

    { text: [
        { text: "Delays in dispatch or loading ", bold: true },
        { text: "until the truck is cleaned." },
      ], style: 'p', margin: [20, 0, 0, 10] },

    { text: "If the interior of your truck is found to be excessively dirty or neglected and requires deep cleaning, the cost of the cleaning will be deducted from your settlement.", bold: true, style: 'p', margin: [20, 0, 0, 10] },

    { text: [
        { text: "This policy applies to " },
        { text: "all drivers", bold: true },
        { text: ", including those currently under contract. By signing below, you acknowledge that you have read, understood, and agree to comply with this requirement going forward." },
      ], style: 'p', margin: [0, 0, 0, 20] },
    { canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0,-22, 0, 0]},
    { text: "Driver's Name", style: 'label', margin: [0,5,0,0]},
    { text: "Driver's Signature", style: 'label', margin: [170,-12,0,0]},
    { text: `${date}`, margin: [340,-32, 0, 0]},
    { text: "Date", style: 'label', margin: [340,5,0,0] },

    { text: '', pageBreak: 'before' },
  ];
};